import { createGlobalStyle } from "styled-components";

const GlobalStyle = createGlobalStyle`
  :root {
    --primary-color: ${props => props.theme.primaryColor};
    --primary-color-hover: ${props => props.theme.primaryColorHover || props.theme.primaryColor};
    --primary-color-pressed: ${props => props.theme.primaryColorPressed || props.theme.primaryColor};
    --surface-1: ${props => props.theme.panel};
    --surface-2: ${props => props.theme.panel2};
    --text-primary: ${props => props.theme.text};
    --text-secondary: ${props => props.theme.text2};
    --text-muted: ${props => props.theme.text3};
    --text-disabled: ${props => props.theme.disabledText};
    --text-on-brand: ${props => props.theme.selectedText};
    --focus-color: ${props => props.theme.focus};
    --overlay-color: ${props => props.theme.overlay};
    --xr-viewer-background: ${props => props.theme.viewerBackground};
    --success-color: ${props => props.theme.green};
    --warning-color: ${props => props.theme.yellow};
    --danger-color: ${props => props.theme.danger};
    --primary-font: ${props => props.theme.lato};
    --text1-color: ${props => props.theme.background};
    --text5-color: ${props => props.theme.white};
    --border-radius-regular: ${props => props.theme.borderRadiusRegular};
    --border-radius-small: ${props => props.theme.borderRadiusSmall};
    --font-family-default: ${props => props.theme.lato};
    --Gray-3: ${props => props.theme.text3};
    --Gray-4: ${props => props.theme.border};
    --Red: ${props => props.theme.red};
  }

  /*! minireset.css v0.0.4 | MIT License | github.com/jgthms/minireset.css */
  html,
  body,
  p,
  ol,
  ul,
  li,
  dl,
  dt,
  dd,
  blockquote,
  figure,
  fieldset,
  legend,
  textarea,
  pre,
  iframe,
  hr,
  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    margin: 0;
    padding: 0;
  }

  h1,
  h2,
  h3,
  h4,
  h5,
  h6 {
    font-size: 100%;
    font-weight: normal;
  }

  ul {
    list-style: none;
  }

  button,
  input,
  select,
  textarea {
    margin: 0;
  }

  html {
    box-sizing: border-box;
  }

  *, *:before, *:after {
    box-sizing: inherit;
  }

  img,
  embed,
  iframe,
  object,
  video {
    height: auto;
    max-width: 100%;
  }

  audio {
    max-width: 100%;
  }

  iframe {
    border: 0;
  }

  table {
    border-collapse: collapse;
    border-spacing: 0;
  }

  td,
  th {
    padding: 0;
    text-align: left;
  }

  /* scrollbar-width is not inherited so apply to all elements. */
  * {
    scrollbar-width: thin;
  }

  ::selection {
    color: ${props => props.theme.text};
    background-color: ${props => props.theme.selected};
  }

  a {
    color: ${props => props.theme.text};

    &:hover {
      color: ${props => props.theme.blueHover};
    }

    &:active {
      color: ${props => props.theme.bluePressed};
    }
  }

  html, body {
    width: 100%;
    height: 100%;
  }

  #app {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    background-color: ${props => props.theme.background};
  }

  main {
    display: flex;
    flex-direction: column;
    flex: 1;
  }

  body {
    font-family: ${props => props.theme.lato};
    font-size: ${props => props.theme.defaultFont};
    color: ${props => props.theme.text};
    background-color: ${props => props.theme.background};
    scrollbar-color: var(--colorBrandBackground) var(--colorNeutralBackground4);
  }

  .Modal {
    position: absolute;
    display: flex;
    flex: 1;
    outline: none;
    max-height: 100%;
    box-shadow: ${props => props.theme.shadow30};
    margin-bottom: 10vh;
  }

  .Overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: ${props => props.theme.overlay};
  }

  .ReactModal__Overlay--after-open {
    z-index: 100;
  }

  .sentry-error-embed {
    .form-field {
      margin-top: 20px;
    }

    .form-field:not(:last-child) {
      display: none;
    }
  }

  #editor-container .fui-Switch {
    transform: scale(0.8);
    margin-left: -2rem;
  }

  body * {
    scrollbar-color: var(--colorBrandBackground) var(--colorNeutralBackground4);
  }

  body > *::-webkit-scrollbar-button {
    display: none;
  }

  body > *::-webkit-scrollbar-button:vertical:decrement,
  body > *::-webkit-scrollbar-button:vertical:increment {
    display: none; /* Specifically hide the up/down buttons */
    height: 0; /* Ensure no space is left for the button */
  }

  /* Keep Fluent UI focus ring inside elements to avoid scrollbars on scrollable dialogs */
  [data-fui-focus-visible]::after {
    inset: 0 !important;
  }

  @media screen and (max-width: 480px) {
    .fui-DialogSurface {
      width: 80vw !important;
    }
  }

  .fui-donut__chart {
    margin: auto;
  }

  .menu-item-switch .fui-MenuItemSwitch__switchIndicator {
    transform: scale(0.8);
  }
`;

export default GlobalStyle;
